document.addEventListener('DOMContentLoaded', function () {
    const containers = document.querySelectorAll('.mobile-category-carousel__container');
    const updaters = [];

    containers.forEach(function (container) {
        const carousel = container.querySelector('.mobile-category-carousel__track');
        const scrollbar = container.querySelector('.mobile-category-carousel__scrollbar');
        const thumb = container.querySelector('.mobile-category-carousel__scrollbar-thumb');

        if (!carousel || !scrollbar || !thumb) return;

        function updateScrollbar() {
            const scrollWidth = carousel.scrollWidth;
            const visibleWidth = carousel.clientWidth;

            if (!visibleWidth) return;

            if (scrollWidth <= visibleWidth) {
                scrollbar.style.display = 'none';
                return;
            }

            scrollbar.style.display = 'block';

            const ratio = visibleWidth / scrollWidth;
            thumb.style.width = `${ratio * 100}%`;

            const maxScroll = scrollWidth - visibleWidth;
            const maxMove = scrollbar.clientWidth - thumb.offsetWidth;
            const scrollPercent = maxScroll > 0 ? carousel.scrollLeft / maxScroll : 0;

            thumb.style.transform = `translateX(${scrollPercent * maxMove}px)`;
        }

        carousel.addEventListener('scroll', updateScrollbar);
        window.addEventListener('resize', updateScrollbar);

        if (typeof ResizeObserver !== 'undefined') {
            new ResizeObserver(updateScrollbar).observe(carousel);
        }

        updaters.push(updateScrollbar);
        updateScrollbar();
    });

    function updateAll() {
        requestAnimationFrame(function () {
            updaters.forEach(function (fn) {
                fn();
            });
        });
    }

    window.addEventListener('load', updateAll);

    if (typeof MutationObserver !== 'undefined') {
        new MutationObserver(updateAll).observe(document.body, {
            attributes: true,
            attributeFilter: ['data-mobile-carousel-abtest'],
        });
    }
});
